import React, { useEffect } from "react"
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import * as layoutService from "../../view/layoutService";
import { withMainLayout } from "../../view/LayoutHOCs";
import { InfoBoxes } from "../../info-boxes/InfoBoxes";
import RemediationTableSection from "./RemediationTableSection"

const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "Remediation History",
        redirectTo: "/remediation"
    }
]

function RemediationPage() {

    const history = useHistory();


    useEffect(() => {
        layoutService.setPageTitle('Remediation History')
        layoutService.setBreadcrumbs(breadcrumbs)
    }, [history.location])


    return (
        <>
            <InfoBoxes />
            <RemediationTableSection />
        </>
    );
}


export default withMainLayout(connect()(RemediationPage));
